import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  NgZone,
  OnChanges,
  OnInit,
  Output,
  ViewChild
} from '@angular/core';
import {TimeUtils} from '../../../engine/time-utils';
import {Hotkeys} from '../../../modules/hotkeys/hotkeys.enum';
import {HotkeysService} from '../../../modules/hotkeys/hotkeys.service';

@Component({
  selector: 'gg-progress-bar',
  templateUrl: './progress-bar.component.html',
  styleUrls: ['./progress-bar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProgressBarComponent implements OnInit, OnChanges {
  @Input() current: number;
  @Input() total: number;
  @Input() loaded: number;
  @Input() isLive: boolean;
  @Output() seek = new EventEmitter();

  @ViewChild('bar') bar: ElementRef;

  public played = 50;
  //public hover = 50;
  //public hoverTime = '0:00';

  constructor(hotkeysService: HotkeysService, private zone: NgZone) {
    hotkeysService.on(Hotkeys.seekForward).subscribe(() => this.seekForward());
    hotkeysService.on(Hotkeys.seekBackward).subscribe(() => this.seekBackward());
  }

  ngOnInit() {
    this.zone.runOutsideAngular(() => {
      this.bar.nativeElement.addEventListener('mousemove', this.mouseMove.bind(this));
    });
  }

  ngOnChanges() {
    this.played = this.total ? (this.current / this.total) * 100 : 0;
  }

  mouseMove(event) {
    const divider = this.getX(event.pageX) / this.bar.nativeElement.offsetWidth;
    let hover = divider * 100 - 0.1;

    const hoverDivider = !this.isLive ? divider : -(1 - divider);
    let hoverTime = this.mouseToTime(hoverDivider, this.total);

    this.bar.nativeElement.querySelector('.progress.tip').style.left = hover + '%';
    this.bar.nativeElement.querySelector('.progress-part.float').style.width = hover + '%';
    this.bar.nativeElement.querySelector('.progress.tip .text').textContent = hoverTime;
  }

  mouseToTime(divider, seconds) {
    return TimeUtils.secondsToTime(seconds * divider);
  }

  onSeek(event) {
    const divider = this.getX(event.pageX) / this.bar.nativeElement.offsetWidth;
    this.seek.emit((this.total || 0) * divider);
  }

  getX(pageX) {
    return pageX - this.bar.nativeElement.getBoundingClientRect().x;
  }

  private seekForward() {
    this.seek.emit(this.current + 15);
  }

  private seekBackward() {
    this.seek.emit(this.current - 15);
  }
}
